import React, { useState, useRef, useEffect } from 'react';
import styles from './ProfilePage.module.css';
import { useParams } from "react-router";
import ProfileTab from './ProfileTab/ProfileTab';
import StatsTab from './StatsTab/StatsTab';
import SettingsTab from './SettingsTab/SettingsTab';
import TransactionTab from './TransactionTab/TransactionTab';
import TransactionHistoryTab from './TransactionHistoryTab/TransactionHistoryTab';
import DebatesTab from './DebatesTab/DebatesTab';
import TabNavVertical from './TabNavVertical/TabNavVertical';
import { useAuth } from "../../utils/AuthContext/authcontext";
import CompactNavbar from './../CompactNavbar/CompactNavbar';
import { HiCog6Tooth, HiMiniChevronDoubleRight, HiMiniChevronDoubleLeft  } from 'react-icons/hi2';
import ContactSidebar from './../ContactSidebar/ContactSidebar';

export default function ProfilePage({tabactive = 'Profile'}) {
  const tabs = ['Profile', 'Stats', 'Settings', 'Transactions', 'History', 'Debates'];
  const tabs_sm = ['profile', 'stats', 'settings', 'transactions', 'history', 'debates'];
  const [active, setActive] = useState('Profile');
  const {user, logout} = useAuth();
  const [collapsed, setCollapsed] = useState(true);
  const [isContactOpen, setContactOpen] = useState(false);
  const sidebarRef = useRef();
  let params = useParams();
  
  const mlogout = () => {
  }


   const capitalizeFirstLetter = (val) => {
    return String(val).charAt(0).toUpperCase() + String(val).slice(1);
	}

  useEffect(() => {
	if(tabs.includes(capitalizeFirstLetter(params.tab)) == true){
	    setActive(capitalizeFirstLetter(params.tab));
	}
  }, [params.tab]);

  useEffect(() => {
    if (collapsed) return;
    const handleClickOutside = (e) => {
      if (sidebarRef.current && !sidebarRef.current.contains(e.target)) {
        setCollapsed(true);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [collapsed]);

	useEffect(() => {
	  if (!collapsed && window.innerWidth < 768) {
		document.body.style.overflow = 'hidden';
	  } else {
		document.body.style.overflow = '';
	  }
	}, [collapsed]);

  const handleTab = (tab) => {
    setActive(tab);
    if (window.innerWidth < 768) setCollapsed(true);
  };


  /*const renderContent = () => {
    switch (active) {
      case 'Profile': return <ProfileTab user={user} />;
      case 'Stats': return <StatsTab user={user} />;
      case 'Settings': return <SettingsTab user={user} />;
      case 'Transactions': return <TransactionTab user={user} />;
      case 'History': return <TransactionHistoryTab user={user} />;
      case 'Debates': return <DebatesTab user={user} />;
      default: return null;
    }
  };*/
  
  const renderContent = {
    Profile: <ProfileTab user={user} />,
    Stats: <StatsTab user={user} />,
    Settings: <SettingsTab user={user} />,
    Transactions: <TransactionTab user={user} />,
    History: <TransactionHistoryTab user={user} />,
    Debates: <DebatesTab user={user} />
  }[active];

  return (
    <>
	<div className={styles.header}>
		<CompactNavbar shownow={false} modal={true} scrollY={0} openContact={() => setContactOpen(true)}  openLogin={(user) => {user != null ? logout(true) : mlogout()}}/>
	</div>
    <div className={styles.wrapper}>
      <aside ref={sidebarRef} className={`${styles.sidebar} ${collapsed ? styles.collapsed : ''}`}>
        
		{collapsed == true ? <HiMiniChevronDoubleRight className={styles.collapseBtn}  onClick={() => setCollapsed(!collapsed)}/> : <HiMiniChevronDoubleLeft className={styles.collapseBtn}  onClick={() => setCollapsed(!collapsed)}/>}
		
        <div className={styles.avatarWrapper}>
          <ProfileTab user={user} readOnly collapsed={collapsed} compact={true} />
        </div>
        <TabNavVertical
          tabs={tabs}
          active={active}
          onSelect={handleTab}
          iconOnly={collapsed}
        />
      </aside>
      <main className={styles.mainContent}>{renderContent}</main>
    </div>
	<ContactSidebar isOpen={isContactOpen} onClose={() => setContactOpen(false)} />
	</>
  );

}
